import React, { ReactNode } from "react";
import { Divider, Header } from "semantic-ui-react";

import styles from "./PickActions.module.css";

type Props = {
  children: ReactNode;
};
const PickActions = ({ children }: Props) => {
  return (
    <section className={styles["pick-actions-section"]}>
      <Divider horizontal>
        <Header as="h3">
          {/* <Icon name="exclamation" /> */}
          Åtgärder
        </Header>
      </Divider>
      <div role="group" aria-label="Pick actions" className={styles["pick-actions"]}>
        {children}
      </div>
    </section>
  );
};

export default PickActions;
